<template>
    <div class="ReportPreview">
        <div v-if="reportInfoData.previewimagelist.length === 0" v-loading="isSuccess" class="content_box">
            <pdf v-for="item in numPages" :key="item" :src="reportInfoData.fullfileurl" :page="item" />
        </div>
        <div v-else v-loading="isSuccess" class="content_box">
            <img @click="seeImg(index)" v-for="(item, index) in reportInfoData.previewimagelist" :key="index" v-lazy="item.atturl" alt="">
        </div>
        <div class="preview_btn" v-if="reportInfoData.isjoin===0">
            <p class="tipsText">报告预览完啦，快去获取查看完整报告吧！</p>
            <van-button type="primary" v-if="reportInfoData.feetype===1" @click="freeGet"><img :src="require('@/common/images/report/mobile/mFree.png')" alt="">免费获取</van-button>
            <van-button type="primary" v-if="reportInfoData.feetype===2"  @click="buyNow"><img :src="require('@/common/images/report/mobile/mCar.png')" alt="">立即购买</van-button>
        </div>
    </div>
</template>

<script>
    import pdf from 'vue-pdf'
    import {getPreviewReportInfo,updateJoinReport} from 'api/reportApi'
    import {Toast} from 'vant'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        metaInfo: {
            meta: [
                { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes' }
            ]
        },
        name: "MReportPreview",
        data(){
            return{
                numPages: '', // pdf文件总页数
                isSuccess: true,
                showPop: true,
                reportInfoData: {
                    previewimagelist: []
                },
            }
        },
        activated () {
            if (this.refresh) {
                this.findPreviewReportInfo();
                this.setRefresh(false)
            }
        },
        mounted() {
            if (!this.refresh){
                this.findPreviewReportInfo()
            }
            // if (window.history && window.history.pushState) {
            //     // 向历史记录中插入了当前页
            //     history.pushState(null, null, document.URL);
            //     window.addEventListener('popstate', this.goBack, false);
            // }
        },
        // destroyed () {
        //     window.removeEventListener('popstate', this.goBack, false);
        // },
        methods:{
            // 查看图片
            seeImg(index){
                let arr = [];
                this.reportInfoData.previewimagelist.forEach(item=>{
                    arr.push(item.atturl)
                });
                this.$imagePreview({images:arr,startPosition:index});
            },
            // pdf加载时
            loadPdfHandler() {
                this.setLoading(true)
                this.reportInfoData.fullfileurl.then(pdf => {this.numPages = pdf.numPages;})
                setTimeout(() => {
                    this.setLoading(false)
                }, 2000)
            },
            // 获取预览报告信息
            findPreviewReportInfo(retype) {
                this.setLoading(true);
                this.isSuccess = true;
                let params = {
                    reportid: this.$route.query.reportid,
                    retype: retype || parseInt(this.$route.query.retype) //1查看 2预览
                };
                getPreviewReportInfo({
                    data: Object.assign({}, params),
                    success: data => {                        
                        this.setLoading(false);
                        this.reportInfoData = data.data;
                        this.isSuccess = false;                        
                        if(parseInt(this.$route.query.retype)===1 && this.reportInfoData.isjoin===0){
                            this.$router.push({name: 'MReportDetails', query: {reportid: this.reportInfoData.reportid}})
                        }
                        else if(this.reportInfoData.previewimagelist.length<1&&this.reportInfoData.fullfileurl){                            
                            //20201229增加，如果文件大小大于5M，则直接打开PDF，不用加载
                            // console.log(this.reportInfoData.fullfileurl)
                            // this.reportInfoData.fullfileurl = ''
                            if(this.reportInfoData.filesize>=5*1000*1000){
                                location.href=this.reportInfoData.fullfileurl
                                // location.href="http://www.baidu.com"
                            }
                            else{
                                if(this.reportInfoData.fullfileurl){
                                    this.reportInfoData.fullfileurl = pdf.createLoadingTask(this.reportInfoData.fullfileurl);
                                    this.loadPdfHandler()
                                }
                            }
                        }
                    },
                    error: data => {
                        this.setLoading(false);
                        this.isSuccess = true;
                        Toast(data.msg);
                    }
                })
            },
            // 免费获取
            freeGet(){
                this.setLoading(true);
                let params = {
                    reportid: this.$route.query.reportid,
                };
                updateJoinReport({
                    data: Object.assign({}, params),
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        Toast('你已获取成功！');
                        this.findPreviewReportInfo(1)
                    },
                    error: data => {
                        Toast(data.msg);
                    }
                })
            },
            // 立即购买
            buyNow() {
                this.$router.push({name: 'MConfirmOrder', query: {reportid: this.reportInfoData.reportid, kmctype: 2}})
            },
            // goBack () {
            //     console.log('点击了返回按钮')
            //     this.setRefresh(true);
            //     // this.$router.go(-1);
            // },
            ...mapActions([
                'setLoading',
                'setRefresh'
            ])
        },
        computed: {
            ...mapGetters(['refresh'])
        },
        components: {
            pdf
        }
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .ReportPreview{
        background: #fff;
        padding-bottom: 0.2rem;
        .content_box {
            margin: 0 auto 0.2rem;
            img{
                width: 100%;
            }
        }
        .preview_btn{
            .tipsText{
                color: #F56C6C;
                font-size: 0.28rem;
                margin: 0.4rem;
                text-align: center;
            }
            .van-button{
                width: 2.85rem;
                height: 0.76rem;
                line-height: 0.76rem;
                font-size: 0.3rem;
                border: none;
                display: flex;
                flex-direction: row;
                justify-content: center;
                margin: 0 auto;
                .van-button__text{
                    line-height: 0.76rem;
                    display: flex;
                    align-items: center;
                }
                img{
                    width: 0.36rem;
                    height: 0.36rem;
                    margin-right: 0.1rem;
                }
            }
            .van-button--primary{
                background:rgba(245,108,108,1);
            }
        }
    }
</style>